import type { Tagged } from "@-/com.npmjs.type-fest";
import type { MorphemeDetailsTileSlice } from "@-/dev.improve.haniverse.lib.morpheme.entities";
import { hasLength } from "@-/com.npmjs.ts-array-length";
import { createGate } from "@-/dev.improve.haniverse.lib.gate";

type CompoundsListViewData = {
  /** Resolved cards for the revealed window — grows as the section scrolls. */
  cards: MorphemeDetailsTileSlice[];
  compoundCharacterList: string[];
  /** More compounds below the revealed window; render the "more below" footer. */
  hasMore: boolean;
  isCardsPending: boolean;
};

export type MorphemeInfoPanelCompositionCompoundsListViewGate = Tagged<
  CompoundsListViewData,
  "MorphemeInfoPanelCompositionCompoundsListViewGate"
>;

/**
 * Whether the Compounds body renders. `null` is the designed hidden state: the first page of
 * cards is still loading — the loading affordance is the section header's chevron spinner
 * (`isLoading` on the section), so the body stays empty rather than flashing the "Could not load
 * compound cards." fallback before the cards resolve. A grapheme with no compounds at all still
 * renders (its "no compounds" copy).
 */
export function getMorphemeInfoPanelCompositionCompoundsListViewGate(
  data: CompoundsListViewData,
): MorphemeInfoPanelCompositionCompoundsListViewGate | null {
  const isFirstPageLoading =
    !hasLength(data.compoundCharacterList, 0) && data.isCardsPending && hasLength(data.cards, 0);
  return isFirstPageLoading
    ? null
    : createGate<MorphemeInfoPanelCompositionCompoundsListViewGate>(data);
}
